import { BarChart3, FileText, FolderKanban, House } from "lucide-react";

import type {
  SidebarNavContext,
  SidebarNavItem,
  SidebarNavLinkItem,
  SidebarNavSection,
} from "@/navigation/types";

const GENERAL_NAV: SidebarNavItem[] = [
  {
    kind: "link",
    permission: "nav.dashboard",
    to: "/dashboard",
    end: true,
    labelKey: "nav.dashboard",
    icon: House,
  },
  {
    kind: "link",
    permission: "nav.dashboard",
    to: "/acompanhamento",
    end: true,
    labelKey: "nav.tracking",
    icon: BarChart3,
  },
  {
    kind: "link",
    permission: "project.clientBudgets.view",
    to: "/client-budgets",
    end: true,
    labelKey: "nav.clientBudgets",
    icon: FileText,
  },
  {
    kind: "link",
    permission: "nav.projects",
    to: "/projects",
    end: true,
    labelKey: "nav.projects",
    icon: FolderKanban,
  },
];

const APP_SIDEBAR_SECTIONS: SidebarNavSection[] = [{ titleKey: "nav.general", items: GENERAL_NAV }];

function filterByPermission(
  items: SidebarNavItem[],
  can: SidebarNavContext["can"],
): SidebarNavItem[] {
  return items.filter((item) => !item.permission || can(item.permission));
}

function toHomeNavLinks(items: SidebarNavItem[]): SidebarNavLinkItem[] {
  return items.flatMap((item) => {
    switch (item.kind) {
      case "link":
        return [item];
      case "group":
      case "soon":
        return [];
      default: {
        const _exhaustive: never = item;
        return _exhaustive;
      }
    }
  });
}

export function resolveAppHomeNavLinks({ can }: SidebarNavContext): SidebarNavLinkItem[] {
  return toHomeNavLinks(filterByPermission(GENERAL_NAV, can));
}

export function isAppHomeNavActive(pathname: string, to: string, end?: boolean): boolean {
  if (to === "/dashboard") return pathname === "/dashboard" || pathname === "/home";
  if (to === "/acompanhamento") return pathname === "/acompanhamento";
  if (to === "/projects") return pathname === "/projects";
  if (to === "/client-budgets") {
    return pathname === "/client-budgets" || pathname.startsWith("/client-budgets/");
  }
  if (to === "/finance") return pathname === "/finance" || pathname.startsWith("/finance/");
  if (end) return pathname === to;
  return pathname === to || pathname.startsWith(`${to}/`);
}

export function resolveAppSidebarNav({ can }: SidebarNavContext): SidebarNavSection[] {
  return APP_SIDEBAR_SECTIONS.map((section) => ({
    titleKey: section.titleKey,
    items: filterByPermission(section.items, can),
  })).filter((section) => section.items.length > 0);
}
